module.exports = __webpack_public_path__ + "static/media/curve-orange.230353e1.svg";